import { render, staticRenderFns } from "./Level5.vue?vue&type=template&id=6d36a804&"
import script from "./Level5.vue?vue&type=script&lang=js&"
export * from "./Level5.vue?vue&type=script&lang=js&"
import style0 from "./Level5.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports